import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { Book, User, ShoppingCart, Menu, BookOpen, Star, MessageCircle, Mail } from 'lucide-react';

// Pages
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ChaptersPage from './pages/ChaptersPage';
import AuthorPage from './pages/AuthorPage';
import BuyPage from './pages/BuyPage';
import ContactPage from './pages/ContactPage';
import ReadPage from './pages/ReadPage';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-white">
        {/* Navigation */}
        <nav className="bg-gray-900 text-white shadow-lg sticky top-0 z-50">
          <div className="container mx-auto px-4 py-4">
            <div className="flex justify-between items-center">
              <Link to="/" className="text-2xl font-bold flex items-center">
                <Book className="mr-2" />
                The Lost Code Mystery
              </Link>
              <div className="hidden md:flex space-x-8">
                <Link to="/" className="hover:text-amber-400 transition">Home</Link>
                <Link to="/about" className="hover:text-amber-400 transition">About</Link>
                <Link to="/read" className="hover:text-amber-400 transition">Read</Link>
                <Link to="/chapters" className="hover:text-amber-400 transition">Chapters</Link>
                <Link to="/author" className="hover:text-amber-400 transition">Author</Link>
                <Link to="/buy" className="hover:text-amber-400 transition">Buy Now</Link>
                <Link to="/contact" className="hover:text-amber-400 transition">Contact</Link>
              </div>
              <Link to="/buy" className="bg-amber-500 text-gray-900 px-6 py-2 rounded-full font-semibold hover:bg-amber-400 transition flex items-center">
                <ShoppingCart className="mr-2" size={18} />
                Buy Now
              </Link>
            </div>
          </div>
        </nav>

        {/* Main Content */}
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/read" element={<ReadPage />} />
            <Route path="/chapters" element={<ChaptersPage />} />
            <Route path="/author" element={<AuthorPage />} />
            <Route path="/buy" element={<BuyPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </main>

        {/* Footer */}
        <footer className="bg-gray-900 text-white py-12">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
              <div>
                <h3 className="text-xl font-bold mb-4 flex items-center">
                  <Book className="mr-2" /> The Lost Code Mystery
                </h3>
                <p className="text-gray-400">
                  A gripping thriller about secrets, code, and the search for truth.
                </p>
              </div>
              <div>
                <h4 className="font-bold mb-4">Quick Links</h4>
                <ul className="space-y-2 text-gray-400">
                  <li><Link to="/about" className="hover:text-amber-400">About the Book</Link></li>
                  <li><Link to="/chapters" className="hover:text-amber-400">Read Chapters</Link></li>
                  <li><Link to="/author" className="hover:text-amber-400">Meet the Author</Link></li>
                  <li><Link to="/buy" className="hover:text-amber-400">Buy Now</Link></li>
                </ul>
              </div>
              <div>
                <h4 className="font-bold mb-4">Connect</h4>
                <ul className="space-y-2 text-gray-400">
                  <li><Link to="/contact" className="hover:text-amber-400">Contact</Link></li>
                  <li><Link to="/newsletter" className="hover:text-amber-400">Newsletter</Link></li>
                  <li><Link to="/reviews" className="hover:text-amber-400">Reviews</Link></li>
                </ul>
              </div>
              <div>
                <h4 className="font-bold mb-4">Stay Updated</h4>
                <p className="text-gray-400 mb-4">Get the latest news and exclusive content.</p>
                <div className="flex">
                  <input type="email" placeholder="Your email" className="px-4 py-2 rounded-l-lg text-gray-900 flex-1" />
                  <button className="bg-amber-500 text-gray-900 px-4 py-2 rounded-r-lg font-semibold hover:bg-amber-400">
                    Subscribe
                  </button>
                </div>
              </div>
            </div>
            <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
              <p>&copy; 2026 Victor Grösser. All rights reserved.</p>
            </div>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;